import { render, staticRenderFns } from "./ChatTodoV2.vue?vue&type=template&id=c73c90e8&scoped=true"
import script from "./ChatTodoV2.vue?vue&type=script&lang=js"
export * from "./ChatTodoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73c90e8",
  null
  
)

export default component.exports